import { render, staticRenderFns } from "./Garden.vue?vue&type=template&id=7431065e"
import script from "./Garden.vue?vue&type=script&lang=js"
export * from "./Garden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports